import Container from './Container';

function App() {
  return (
    <div className='App'>
      <Container />
    </div>
  );
}

export default App;
